import * as Yup from 'yup';

const ClientSchema = Yup.object({
  clientName: Yup.string()
    .trim()
    .min(2, 'Please enter at least 2 characters')
    .max(60, 'Please enter no more than 60 characters')
    .required('Client name is required'),
});

export default ClientSchema;
